import React from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import {
  Http, i18n, BASE_URL,
  OAUTH2_CLIENT, OAUTH2_REDIRECT_URI,
} from 'common';

export class OAuth2Provider extends React.Component {
  static childContextTypes = {
    oauth: PropTypes.object.isRequired
  }

  state = {
    authorized: false,
    expired: false
  }

  getChildContext() {
    return { oauth: { reset: this.reset } }
  }

  reset = () => {
    this.setState({expired: true});
  }

  componentWillMount() {
    const channel = new BroadcastChannel('openid_admin_channel');
    channel.onmessage = (ev) => {
      this.authorize(ev.data);
    }

    const location = window.location||{};
    const params = qs.parse(location.hash);

    const error = params.error || params['/error'];
    if (error) { throw error; }

    const token = params.access_token || params['/access_token'];
    const state = params.state;

    if (token == null) {
      window.location =
        `${BASE_URL}/authorize?client_id=${OAUTH2_CLIENT}&redirect_uri=${OAUTH2_REDIRECT_URI}&response_type=token` +
          (params.authorize ? '&state=modal' : '');

      return;
    }

    window.location.hash = '';

    if (state === 'modal') {
      channel.postMessage(token);
      close();
    } else {
      this.authorize(token);
    }
  }

  authorize = (token) => {
    Http.setBearerToken(token);
    this.setState({authorized: true, expired: false});
  }

  render() {
    const { authorized, expired } = this.state;
    return (
      <div>
        {expired &&
          <div className="alert alert--error alert--no-margin">
            <a href={`${OAUTH2_REDIRECT_URI}#authorize=1`} target='_blank'>
              {i18n('error.token-expired')}
            </a>
          </div>}
        {authorized ? this.props.children : null}
      </div>
    );
  }
}
